import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'

// NewRelic BrowserAgent は、ブラウザの動作を監視するために設計された JavaScript エージェント。そのため、その内部実装は window オブジェクトの存在を前提としている。
// SSR 中に window オブジェクトにアクセスしようとするとエラーが発生してしまう。そのため .client.ts 拡張子をファイル名に付与することにより、クライアントサイドでのみ実行される
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  // licenseKey / applicationID は環境変数(NEW_RELIC_BA_*)から供給される。
  // ローカル環境ではこれらが未設定で NewRelic へ接続できず、agent を起動しても
  // warning#43(abort) や feature チャンクのロード失敗(#34 等)を招くだけなので、起動をスキップする。
  const licenseKey = config.public.NEW_RELIC_BA_LICENSE_KEY as string
  const applicationID = config.public.NEW_RELIC_BA_APP_ID as string
  if (!licenseKey || !applicationID) {
    return
  }

  const options = {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
      // browserAgent.log()の内容をNewRelicで監視するために必要。
      // ここで設定する`level`は、NewRelicに送信するログの最低重要度。
      // ここで'info'を設定した場合、info、warn、errorレベルのログが送信される。
      // 実際にNewRelicに出力されるログの設定はBrowser Logsにて設定する。
      logging: { enabled: true, autoStart: true, level: 'info' },
      // このアプリは SPA のため、画面遷移してもブラウザのフルリロードは発生しない。
      // soft_navigations を有効にして、History API ベースの仮想ページ遷移を NewRelic 上でも画面遷移として追跡できるようにする。
      soft_navigations: { enabled: true, autoStart: true },
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey,
      applicationID,
      sa: 1,
    },
    loader_config: {
      accountID: config.public.NEW_RELIC_BA_ACCOUNT_ID as string,
      trustKey: config.public.NEW_RELIC_BA_TRUST_KEY as string,
      agentID: config.public.NEW_RELIC_BA_AGENT_ID as string,
      licenseKey,
      applicationID,
    },
  }

  // BrowserAgent のコンストラクタが内部で run() を実行してエージェントを起動する。
  // ここで明示的に run() を呼ぶと全フィーチャ（Logs 等）が二重に初期化され、
  // ログ・イベントが2回送信されてしまうため呼ばない。
  // 生成したインスタンスは参照しないため変数には受けない。
  new BrowserAgent(options)
})
